import { Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import CustomInput from '../../components/customInput/CustomInput';
import MyCustomImageUploader from '../../components/imageInput/MyCustomImageUploader';
import { SettingModel } from '../../config/types/models/SettingModel';
import { useAwsUpload } from '../../dataProviders/useAwsUpload';

type IProps = {
  setting: SettingModel;
  setSetting: (s: SettingModel) => void;
};

function GeneralSetting({ setting, setSetting }: IProps) {
  const t = useTranslate();
  const { loading, upload } = useAwsUpload();

  const onChangeImage = async (f: File[], b: string[]) => {
    if (f.length > 0) {
      const newImageUrl = await upload(f[0]);
      setSetting({ ...setting, COMPANY_LOGO: newImageUrl });
    } else {
      setSetting({ ...setting, COMPANY_LOGO: '' });
    }
  };

  return (
    <Paper sx={{ padding: 2, marginTop: 2 }}>
      <Typography variant='subtitle2'>{t('generalSetting')}</Typography>
      <CustomInput
        value={setting?.COMPANY_NAME || ''}
        onChange={(e) => {
          setSetting({ ...setting, COMPANY_NAME: e.target.value });
        }}
        label={t('COMPANY_NAME')}
      />

      <CustomInput
        value={setting?.COMPANY_ORG_NUMBER || ''}
        onChange={(e) => {
          setSetting({ ...setting, COMPANY_ORG_NUMBER: e.target.value });
        }}
        label={t('COMPANY_ORG_NUMBER')}
      />

      <CustomInput
        value={setting?.COMPANY_CITY || ''}
        onChange={(e) => {
          setSetting({ ...setting, COMPANY_CITY: e.target.value });
        }}
        label={t('COMPANY_CITY')}
      />

      <CustomInput
        value={setting?.COMPANY_STREET || ''}
        onChange={(e) => {
          setSetting({ ...setting, COMPANY_STREET: e.target.value });
        }}
        label={t('COMPANY_STREET')}
      />

      <MyCustomImageUploader
        single={true}
        onChange={onChangeImage}
        image={setting?.COMPANY_LOGO || ''}
      />
    </Paper>
  );
}

export default GeneralSetting;
